<template>
    <div class="ref-user-modal">
        <div class="ref-user-modal__content">
            <img
                src="~@/assets/images/ref-user-link/people.svg"
                alt="Рекомендуй возможности и получай баллы"
                class="ref-user-modal__image"
            />
            <h5 class="ref-user-modal__title">
                Рекомендуй возможности <br />
                и получай баллы
            </h5>

            <div class="ref-user-modal__statistics">
                <Score :count="friendsCount" text="ПРИГЛАШЕНО" smallText="друзей" icon="friends" />
                <Score :count="scoresCount" text="БАЛЛЫ ЗА ДРУЗЕЙ" :smallText="getScoreSmallText(scoresCount)" icon="scores" />
            </div>

            <div class="ref-user-modal__instruction">
                <RefInstruction />
            </div>

            <div class="ref-user-modal__shared">
                <RefUserShared v-if="refLink" :ref-link="refLink" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RefUserShared from './RefUserShared.vue';
import Score from './components/Score.vue';
import RefInstruction from './RefInstruction.vue';
import pluralize from '@/tools/pluralize.js';

export default {
    name: 'RefUserModal',
    components: { RefUserShared, RefInstruction, Score },
    props: {
        refLink: {
            type: String,
            default: '',
        },
        friendsCount: {
            type: Number,
            default: 0,
        },
        scoresCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapGetters(['isMobile']),
    },
    methods: {
        getScoreSmallText(count) {
            return `${pluralize(count, 'балл', 'балла', 'баллов')}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.ref-user-modal {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    overflow: hidden;

    @include on-desktop {
        width: urem(598);
        padding-top: urem(44);
    }

    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 0 urem(20);

        @include on-desktop {
            padding: 0 urem(40);
        }
    }

    &__image {
        width: urem(126);
        height: urem(144);

        margin: 0 0 urem(5) 0;

        @include on-desktop {
            width: urem(156);
            height: urem(168);
            margin: 0 0 urem(24) 0;
        }
    }

    &__title {
        font-size: urem(18);
        font-weight: 600;
        color: rgba(37, 31, 69, 1);
        margin: 0 0 urem(12) 0;
        line-height: urem(24);

        @include on-desktop {
            font-size: urem(26);
            font-weight: 500;
            margin: 0 0 urem(24) 0;
            line-height: urem(26);
        }
    }

    &__statistics {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: urem(10);
        width: 100%;
        margin-bottom: urem(24);

        @include on-desktop {
            flex-direction: row;
        }
    }

    &__shared {
        margin-bottom: urem(24);
    }

    &__instruction {
        width: 100%;
        margin-bottom: urem(24);
    }
}
</style>
